import { defineAsyncComponent } from 'vue';

export { type TaskSetItem, type PhaseAndMilestoneListItemType } from './types';

export { emptyTaskBundle } from './components/ProjectPhases/projectPhasesUtils';

export const projectPhaseMicroFrontends = {
	ProjectsPhases: defineAsyncComponent(
		() => import('./components/ProjectPhases')
	),
};
